import { getApp } from "firebase/app";
import { getFirestore, collection } from "firebase/firestore";
// =============================== BASE  ===============================  //
const app = getApp();

export const REF = {
  NAME: "finance",
  COLLECTIONS: {
    SUPPORTER: "supporter",
    LIFE: "life",
  },
};

export const getRefs = () => {
  const firestore = getFirestore(app, REF.NAME);
  const CREF = {
    supporter: collection(firestore, REF.COLLECTIONS.SUPPORTER),
    life: collection(firestore, REF.COLLECTIONS.LIFE),
  };
  return CREF;
};
